export default class TabHelper {
  static replaceTabs(content) {
    if (typeof content !== 'string') {
      return content;
    }
    return content.replace(/\t/g, '');
  }

  static tabKeyboardHandler() {
    return false;
  }
}
